import { Link } from "react-router-dom";
import { Mountain } from "lucide-react";

const COLUMNS = [
  {
    title: "Coverage",
    links: [
      { label: "News", to: "/news" },
      { label: "Projects", to: "/projects" },
      { label: "Companies", to: "/companies" },
      { label: "Commodities", to: "/commodities" },
      { label: "Regions", to: "/regions" },
    ],
  },
  {
    title: "Intelligence",
    links: [
      { label: "Policy Tracker", to: "/policy-tracker" },
      { label: "Data Room", to: "/data-room" },
      { label: "Newsletter", to: "/newsletter" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/" },
      { label: "Editorial Standards", to: "/" },
      { label: "Contact", to: "/" },
      { label: "Press", to: "/" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      className="bg-bb-navy text-white mt-20"
      data-testid="footer"
    >
      <div className="bb-container py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-flex items-center justify-center w-8 h-8 bg-white text-bb-navy">
                <Mountain size={18} strokeWidth={2.2} />
              </span>
              <span className="font-archivo font-extrabold tracking-tight text-lg leading-none">
                BEDROCK<span className="text-bb-copper">BULLETIN</span>
              </span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed max-w-xs">
              Independent intelligence on the projects, policies, commodities
              and companies shaping Canada&rsquo;s mining sector.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} data-testid={`footer-col-${col.title.toLowerCase()}`}>
              <h4 className="bb-overline text-white/70 mb-4">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-white/90 hover:text-bb-copper transition-colors"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-white/55 font-mono">
            &copy; {new Date().getFullYear()} BedrockBulletin Media Inc. ·
            Published in Toronto &amp; Vancouver.
          </p>
          <div className="flex items-center gap-5 text-xs text-white/55 font-mono uppercase tracking-widest">
            <span>Privacy</span>
            <span>Terms</span>
            <span>Disclosures</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
